// Only real shared constants.
export const FORMATS = { INPUT: 'DD.MM.YYYY', DISPLAY: 'Month YYYY' };
